import React from "react"
import style from "./Load.module.css"
import Animate, { AnimationTypes } from "../Animate/Animate"

const Load: React.FC = () => {
  return (
    <Animate type={AnimationTypes.fadeIn} duration="0.3s">
      <div className={style.loadPopup}>
        <div className={style.spinner}></div>
      </div>
    </Animate>
  )
}

export default Load
